import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import NotificationMessageService from "../services/NotificationMessageService";

const useNotificationMessageService = () => {
  const { client } = useApiContext();

  const service = useMemo(() => {
    return new NotificationMessageService(client);
  }, [client]);

  return service;
};

export default useNotificationMessageService;
